<shared-global-error
  data-testid="global-error"
  [title]="'error.global.title' | translate"
  [message]="'CLIENT_TOKEN_ERROR' | translate"
  [hasReload]="false"
  [unknownError]="true" />
